import * as React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface MetadataSectionProps {
  title: string;
  children: React.ReactNode;
}

const MetadataSection: React.FC<MetadataSectionProps> = ({ title, children }) => (
  <Card>
    <CardContent className="space-y-5 py-5">
      <h3 className="revy-cjk text-base font-medium leading-[1.5]">{title}</h3>
      {children}
    </CardContent>
  </Card>
);

export { MetadataSection };
